import React, { useState, useEffect } from 'react';
import axios from 'axios';
import logo from '../imgs/logo.png';

// Componente auxiliar para reemplazar el select multiple nativo
const CustomMultiList = ({ items, selectedTempIds, onToggle, height = "400px", labelKey = "label", valueKey = "value" }) => {
  return (
    <div 
      className="form-control p-0" 
      style={{ 
        height: height, 
        overflowY: 'auto', 
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        borderRadius: '0.375rem'
      }}
    >
      <ul className="list-group list-group-flush">
        {items.length === 0 ? (
          <li className="list-group-item text-muted small italic text-center py-4">Sin elementos</li>
        ) : (
          items.map((item) => {
            const id = String(item[valueKey]);
            const isHighlighted = selectedTempIds.includes(id);
            return (
              <li 
                key={id}
                className={`list-group-item list-group-item-action py-1 px-2 small ${isHighlighted ? 'bg-primary text-white' : ''}`}
                style={{ cursor: 'pointer', userSelect: 'none', fontSize: '0.85rem' }}
                onClick={() => onToggle(id)}
              >
                {item[labelKey]}
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

const SugeridoPage = () => {
  // --- ESTADOS ---
  const [regiones, setRegiones] = useState([]);
  const [loadingRegiones, setLoadingRegiones] = useState(true);
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(true);
  const [grupos, setGrupos] = useState([]);
  const [loadingGrupos, setLoadingGrupos] = useState(true);
  const [lineas, setLineas] = useState([]);
  const [loadingLineas, setLoadingLineas] = useState(true);
  const [marcasProducto, setMarcasProducto] = useState([]);
  const [loadingMarcasProducto, setLoadingMarcasProducto] = useState(false);
  const [modelos, setModelos] = useState([]);
  const [loadingModelos, setLoadingModelos] = useState(false);
  const [anos, setAnos] = useState([]);
  const [loadingAnos, setLoadingAnos] = useState(false);

  const [region, setRegion] = useState('');
  const [suggestedItems, setSuggestedItems] = useState(50);
  const [discount, setDiscount] = useState('');
  const [onlyMainApp, setOnlyMainApp] = useState(false);

  // --- CORREO DESTINO (ahora en formulario, no en modal) ---
  const [email, setEmail] = useState('');

  // --- ESTADO DE ENVÍO ---
  const [enviando, setEnviando] = useState(false);
  const [mensajeEnvio, setMensajeEnvio] = useState(null); // { tipo: 'success'|'error', texto: '' }

  // --- VENDEDOR desde URL (?codv=123) ---
  const [codVendedor, setCodVendedor] = useState('');

  // --- SELECCIONES DEFINITIVAS ---
  const [selectedMarcaIds, setSelectedMarcaIds] = useState([]);
  const [selectedLineaIds, setSelectedLineaIds] = useState([]);
  const [selectedMarcaProductoIds, setSelectedMarcaProductoIds] = useState([]);
  const [selectedModeloIds, setSelectedModeloIds] = useState([]);
  const [selectedAnoIds, setSelectedAnoIds] = useState([]);
  

  // --- SELECCIONES TEMPORALES (RESALTADO AZUL) ---
  const [tempAvailableMarcas, setTempAvailableMarcas] = useState([]);
  const [tempSelectedMarcas, setTempSelectedMarcas] = useState([]);
  const [tempAvailableLineas, setTempAvailableLineas] = useState([]);
  const [tempSelectedLineas, setTempSelectedLineas] = useState([]);
  const [tempAvailableMP, setTempAvailableMP] = useState([]);
  const [tempSelectedMP, setTempSelectedMP] = useState([]);
  const [tempAvailableModelos, setTempAvailableModelos] = useState([]);
  const [tempSelectedModelos, setTempSelectedModelos] = useState([]);
  const [tempAvailableAnos, setTempAvailableAnos] = useState([]);
  const [tempSelectedAnos, setTempSelectedAnos] = useState([]);

  // --- LEER codv DE LA URL ---
  useEffect(() => {
    // Soporta tanto ?codv=xxx como hash-based routing /#/sugerido?codv=xxx
    const tryParse = (search) => {
      const params = new URLSearchParams(search);
      return params.get('codv') || '';
    };

    // 1. Query string normal
    let cod = tryParse(window.location.search);

    // 2. Si está en el hash (ej: /#/sugerido?codv=123)
    if (!cod && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      cod = tryParse(hashQuery);
    }

    setCodVendedor(cod);
  }, []);

  useEffect(() => {
    if (mensajeEnvio !== null) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [mensajeEnvio]);

  // --- EFFECTS (CARGA DE DATOS) ---
  useEffect(() => {
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-regiones').then(r => setRegiones(r.data || [])).finally(() => setLoadingRegiones(false));
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-marcas-gabtec?soloChinos=false').then(r => setMarcas(r.data || [])).finally(() => setLoadingMarcas(false));
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-grupos-marcas').then(r => setGrupos(r.data || [])).finally(() => setLoadingGrupos(false));
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-lineas-gabtec').then(r => setLineas(r.data || [])).finally(() => setLoadingLineas(false));
  }, []);

  useEffect(() => {
    if (selectedLineaIds.length === 0) {
      setMarcasProducto([]);
      setSelectedMarcaProductoIds([]);
      return;
    }
    setLoadingMarcasProducto(true);
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-marcas-por-lineas', { params: { cla_ids: selectedLineaIds.join(',') } })
      .then(r => {
        setMarcasProducto(r.data || []);
        const ids = (r.data || []).map(m => String(m.marca_id));
        setSelectedMarcaProductoIds(prev => prev.filter(id => ids.includes(id)));
      })
      .finally(() => setLoadingMarcasProducto(false));
  }, [selectedLineaIds]);

  useEffect(() => {
  if (selectedMarcaIds.length === 0) {
    setModelos([]);
    setSelectedModeloIds([]);
    return;
  }
  setLoadingModelos(true);
  axios.get('https://apigabtecbi.automarco.cl:3003/api/select-modelos-por-marcas', {
    params: { marca_ids: selectedMarcaIds.join(',') }
  })
    .then(r => {
      setModelos(r.data || []);
      const ids = (r.data || []).map(m => String(m.value));
      setSelectedModeloIds(prev => prev.filter(id => ids.includes(id)));
    })
    .finally(() => setLoadingModelos(false));
}, [selectedMarcaIds]);

  useEffect(() => {
  if (selectedMarcaIds.length === 0) {
    setAnos([]);
    setSelectedAnoIds([]);
    return;
  }
  setLoadingAnos(true);
  const params = { marca_ids: selectedMarcaIds.join(',') };
  if (selectedModeloIds.length > 0) {
    params.mod_ids = selectedModeloIds.join(',');
  }
  axios.get('https://apigabtecbi.automarco.cl:3003/api/select-anos-por-modelos', { params })
    .then(r => {
      setAnos(r.data || []);
      const ids = (r.data || []).map(a => String(a.value));
      setSelectedAnoIds(prev => prev.filter(id => ids.includes(id)));
    })
    .finally(() => setLoadingAnos(false));
}, [selectedMarcaIds, selectedModeloIds]);

  // --- DERIVACIÓN DE LISTAS ---
  const availableMarcas = marcas.filter(m => !selectedMarcaIds.includes(String(m.value)));
  const selectedMarcas = marcas.filter(m => selectedMarcaIds.includes(String(m.value)));
  const availableLineas = lineas.filter(l => !selectedLineaIds.includes(String(l.value)));
  const selectedLineas = lineas.filter(l => selectedLineaIds.includes(String(l.value)));
  const availableMP = marcasProducto.filter(m => !selectedMarcaProductoIds.includes(String(m.marca_id)));
  const selectedMP = marcasProducto.filter(m => selectedMarcaProductoIds.includes(String(m.marca_id)));
  const availableModelos = modelos.filter(m => !selectedModeloIds.includes(String(m.value)));
  const selectedModelosList = modelos.filter(m => selectedModeloIds.includes(String(m.value)));
  const availableAnos = anos.filter(a => !selectedAnoIds.includes(String(a.value)));
  const selectedAnosList = anos.filter(a => selectedAnoIds.includes(String(a.value)));

  // --- LÓGICA DE MOVIMIENTO ---
  const handleToggle = (id, setTemp) => {
    setTemp(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const moveRight = (temp, setFinal, setTemp) => {
    if (temp.length === 0) return;
    setFinal(prev => [...new Set([...prev, ...temp])]);
    setTemp([]);
  };

  const moveLeft = (temp, setFinal, setTemp) => {
    if (temp.length === 0) return;
    setFinal(prev => prev.filter(id => !temp.includes(id)));
    setTemp([]);
  };

  const moveAll = (availableItems, setFinal, valueKey = 'value') => {
    const allIds = availableItems.map(item => String(item[valueKey]));
    if (allIds.length === 0) return;
    setFinal(prev => [...new Set([...prev, ...allIds])]);
  };

  const handleGrupoClick = (grupoId) => {
    axios.get(`https://apigabtecbi.automarco.cl:3003/api/select-marcas-gabtec?soloChinos=false&grupo=${grupoId}`)
      .then(r => {
        const idsGrupo = (r.data || []).map(m => String(m.value));
        setTempAvailableMarcas(idsGrupo.filter(id => !selectedMarcaIds.includes(id)));
      });
  };

  // --- ENVIAR SOLICITUD (ahora guarda en BD y notifica al responsable) ---
  const handleEnviarSolicitud = async () => {
    setMensajeEnvio(null);

    if (!email || !email.includes('@')) {
      setMensajeEnvio({ tipo: 'error', texto: '⚠️ Por favor ingrese un correo electrónico válido.' });
      return;
    }
    if (selectedLineaIds.length === 0) {
      setMensajeEnvio({ tipo: 'error', texto: '⚠️ Debe seleccionar al menos una línea de producto.' });
      return;
    }

    setEnviando(true);
    try {
      const response = await axios.post('https://apigabtecbi.automarco.cl:3003/api/solicitar-sugerido', {
        region,
        marcas: selectedMarcaIds,
        modelos: selectedModeloIds,
        anios: selectedAnoIds,
        lineas: selectedLineaIds,
        marcasProducto: selectedMarcaProductoIds,
        cantidadItems: suggestedItems,
        descuento: parseFloat(discount) || 0,
        soloAplicacionPrincipal: onlyMainApp,
        emailDestino: email,
        codVendedor,
      });

      if (response.data.success) {
        setMensajeEnvio({
          tipo: 'success',
          texto: `✅ Solicitud enviada correctamente. El responsable recibirá una notificación para autorizar el pedido sugerido. El Excel será enviado a ${email} una vez aprobado.`,
        });
        // Limpiar formulario después del envío exitoso
        setEmail('');
      } else {
        setMensajeEnvio({ tipo: 'error', texto: '❌ Error al enviar la solicitud. Intente nuevamente.' });
      }
    } catch (error) {
      setMensajeEnvio({ tipo: 'error', texto: '❌ Error: ' + (error.response?.data?.error || error.message) });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="container pb-5">
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="card shadow">
            {/* HEADER */}
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-2">
              <h3 className="mb-0 fs-4">Generador de Pedido Sugerido</h3>
              <div style={{ textAlign: 'right' }}>
                <img src={logo} height="43" alt='Holding Automarco' />
                <br />
                <button 
                  className='btn btn-sm fw-bold shadow' 
                  style={{ 
                    backgroundColor: '#000000',
                    backgroundImage: 'none',
                    color: '#FFFFFF',
                    border: '1px solid #FFFFFF',
                    marginTop: '5px',
                    padding: '6px 12px',
                    fontSize: '0.85rem'
                  }} 
                  onClick={() => {
                    if (window.Android && window.Android.goBackToMainMenu) {
                      window.Android.goBackToMainMenu();
                    } else {
                      console.log("Acción: Menú Principal");
                    }
                  }}
                >
                  Menú Principal
                </button>
              </div>
            </div>

            <div className="card-body">

              {/* Mensaje de estado de envío */}
              {mensajeEnvio && (
                <div className={`alert alert-${mensajeEnvio.tipo === 'success' ? 'success' : 'danger'} alert-dismissible`} role="alert">
                  {mensajeEnvio.texto}
                  <button type="button" className="btn-close" onClick={() => setMensajeEnvio(null)}></button>
                </div>
              )}

              {/* Región */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label fw-bold text-primary">1. Seleccione Región</label>
                  <select className="form-select border-primary" value={region} onChange={e => setRegion(e.target.value)}>
                    <option value="">Nivel Nacional (Todas)</option>
                    {regiones.map(reg => <option key={reg.value} value={reg.value}>{reg.label}</option>)}
                  </select>
                </div>
              </div>

              {/* Marcas Vehículo */}
              <div className="mb-5">
                <h5 className="fw-bold">Marcas de Vehículos</h5>
                <div className="row g-2 align-items-center">
                  <div className="col-md-5">
                    <label className="small text-muted">Disponibles</label>
                    <CustomMultiList items={availableMarcas} selectedTempIds={tempAvailableMarcas} onToggle={(id) => handleToggle(id, setTempAvailableMarcas)} />
                  </div>
                  <div className="col-md-2 d-flex flex-column gap-2 px-3">
                    <button className="btn btn-sm btn-secondary" style={{fontSize: '0.65rem'}} onClick={() => moveAll(availableMarcas, setSelectedMarcaIds)}>Todos &gt;&gt;</button>
                    <button className="btn btn-sm btn-primary" style={{fontSize: '0.65rem'}} onClick={() => moveRight(tempAvailableMarcas, setSelectedMarcaIds, setTempAvailableMarcas)}>Sumar &gt;&gt;</button>
                    <button className="btn btn-sm btn-outline-primary" style={{fontSize: '0.65rem'}} onClick={() => moveLeft(tempSelectedMarcas, setSelectedMarcaIds, setTempSelectedMarcas)}>&lt;&lt; Quitar</button>
                    <hr className="my-1" />
                    <div className="d-grid gap-1">
                      {grupos.map(g => (
                        <button key={g.value} className="btn btn-outline-secondary" style={{fontSize: '0.65rem'}} onClick={() => handleGrupoClick(g.value)}>{g.label}</button>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-5">
                    <label className="small text-muted">Seleccionadas ({selectedMarcas.length})</label>
                    <CustomMultiList items={selectedMarcas} selectedTempIds={tempSelectedMarcas} onToggle={(id) => handleToggle(id, setTempSelectedMarcas)} />
                  </div>
                </div>
              </div>
              {/* Modelos de Vehículo */}
              <div className="mb-5">
                <h5 className="fw-bold">
                  Modelos de Vehículo <small className="fw-normal text-muted">(Opcional)</small>
                </h5>
                {loadingModelos && <div className="small text-muted mb-2">Cargando modelos...</div>}
                <div className="row g-2 align-items-center">
                  <div className="col-md-5">
                    <label className="small text-muted">Disponibles</label>
                    <CustomMultiList
                      items={availableModelos}
                      selectedTempIds={tempAvailableModelos}
                      onToggle={(id) => handleToggle(id, setTempAvailableModelos)}
                      height="200px"
                    />
                  </div>
                  <div className="col-md-2 d-flex flex-column gap-2 px-3">
                    <button className="btn btn-sm btn-secondary" style={{fontSize: '0.65rem'}} onClick={() => moveAll(availableModelos, setSelectedModeloIds)}>Todos &gt;&gt;</button>
                    <button className="btn btn-sm btn-primary" style={{fontSize: '0.65rem'}} onClick={() => moveRight(tempAvailableModelos, setSelectedModeloIds, setTempAvailableModelos)}>Sumar &gt;&gt;</button>
                    <button className="btn btn-sm btn-outline-primary" style={{fontSize: '0.65rem'}} onClick={() => moveLeft(tempSelectedModelos, setSelectedModeloIds, setTempSelectedModelos)}>&lt;&lt; Quitar</button>
                  </div>
                  <div className="col-md-5">
                    <label className="small text-muted">Seleccionados ({selectedModelosList.length})</label>
                    <CustomMultiList
                      items={selectedModelosList}
                      selectedTempIds={tempSelectedModelos}
                      onToggle={(id) => handleToggle(id, setTempSelectedModelos)}
                      height="200px"
                    />
                  </div>
                </div>
                {selectedMarcaIds.length === 0 && (
                  <div className="small text-muted mt-1">Seleccione al menos una marca de vehículo para ver sus modelos.</div>
                )}
              </div>
              {/* Años de Vehículo */}
              <div className="mb-5">
                <h5 className="fw-bold">
                  Años de Vehículo <small className="fw-normal text-muted">(Opcional)</small>
                </h5>
                {loadingAnos && <div className="small text-muted mb-2">Cargando años...</div>}
                <div className="row g-2 align-items-center">
                  <div className="col-md-5">
                    <label className="small text-muted">Disponibles</label>
                    <CustomMultiList
                      items={availableAnos}
                      selectedTempIds={tempAvailableAnos}
                      onToggle={(id) => handleToggle(id, setTempAvailableAnos)}
                      height="200px"
                    />
                  </div>
                  <div className="col-md-2 d-flex flex-column gap-2 px-3">
                    <button className="btn btn-sm btn-secondary" style={{fontSize: '0.65rem'}} onClick={() => moveAll(availableAnos, setSelectedAnoIds)}>Todos &gt;&gt;</button>
                    <button className="btn btn-sm btn-primary" style={{fontSize: '0.65rem'}} onClick={() => moveRight(tempAvailableAnos, setSelectedAnoIds, setTempAvailableAnos)}>Sumar &gt;&gt;</button>
                    <button className="btn btn-sm btn-outline-primary" style={{fontSize: '0.65rem'}} onClick={() => moveLeft(tempSelectedAnos, setSelectedAnoIds, setTempSelectedAnos)}>&lt;&lt; Quitar</button>
                  </div>
                  <div className="col-md-5">
                    <label className="small text-muted">Seleccionados ({selectedAnosList.length})</label>
                    <CustomMultiList
                      items={selectedAnosList}
                      selectedTempIds={tempSelectedAnos}
                      onToggle={(id) => handleToggle(id, setTempSelectedAnos)}
                      height="200px"
                    />
                  </div>
                </div>
                {selectedMarcaIds.length === 0 && (
                  <div className="small text-muted mt-1">Seleccione al menos una marca de vehículo para ver los años disponibles.</div>
                )}
              </div>
              {/* Líneas */}
              <div className="mb-5">
                <h5 className="fw-bold">Líneas de Producto</h5>
                <div className="row g-2 align-items-center">
                  <div className="col-md-5">
                    <CustomMultiList items={availableLineas} selectedTempIds={tempAvailableLineas} onToggle={(id) => handleToggle(id, setTempAvailableLineas)} height="200px" />
                  </div>
                  <div className="col-md-2 d-flex flex-column gap-2 px-3">
                    <button className="btn btn-sm btn-secondary" style={{fontSize: '0.65rem'}} onClick={() => moveAll(availableLineas, setSelectedLineaIds)}>Todos &gt;&gt;</button>
                    <button className="btn btn-sm btn-primary" style={{fontSize: '0.65rem'}} onClick={() => moveRight(tempAvailableLineas, setSelectedLineaIds, setTempAvailableLineas)}>Aceptar &gt;&gt;</button>
                    <button className="btn btn-sm btn-outline-primary" style={{fontSize: '0.65rem'}} onClick={() => moveLeft(tempSelectedLineas, setSelectedLineaIds, setTempSelectedLineas)}>&lt;&lt; Borrar</button>
                  </div>
                  <div className="col-md-5">
                    <CustomMultiList items={selectedLineas} selectedTempIds={tempSelectedLineas} onToggle={(id) => handleToggle(id, setTempSelectedLineas)} height="200px" />
                  </div>
                </div>
              </div>

              {/* Marcas de Producto */}
              <div className="mb-5">
                <h5 className="fw-bold">Filtro Marcas de Producto <small className="fw-normal text-muted">(Opcional)</small></h5>
                <div className="row g-2 align-items-center">
                  <div className="col-md-5">
                    <CustomMultiList items={availableMP} selectedTempIds={tempAvailableMP} onToggle={(id) => handleToggle(id, setTempAvailableMP)} height="200px" labelKey="marca_nombre" valueKey="marca_id" />
                  </div>
                  <div className="col-md-2 d-flex flex-column gap-2 px-3">
                    <button className="btn btn-sm btn-secondary" style={{fontSize: '0.65rem'}} onClick={() => moveAll(availableMP, setSelectedMarcaProductoIds, 'marca_id')}>Todos &gt;&gt;</button>
                    <button className="btn btn-sm btn-primary" style={{fontSize: '0.65rem'}} onClick={() => moveRight(tempAvailableMP, setSelectedMarcaProductoIds, setTempAvailableMP)}>Aceptar &gt;&gt;</button>
                    <button className="btn btn-sm btn-outline-primary" style={{fontSize: '0.65rem'}} onClick={() => moveLeft(tempSelectedMP, setSelectedMarcaProductoIds, setTempSelectedMP)}>&lt;&lt; Borrar</button>
                  </div>
                  <div className="col-md-5">
                    <CustomMultiList items={selectedMP} selectedTempIds={tempSelectedMP} onToggle={(id) => handleToggle(id, setTempSelectedMP)} height="200px" labelKey="marca_nombre" valueKey="marca_id" />
                  </div>
                </div>
              </div>

              {/* Configuración Final */}
              <div className="row g-3 mb-4">
                <div className="col-md-3">
                  <label className="form-label fw-bold">Cantidad de Ítems</label>
                  <select className="form-select" value={suggestedItems} onChange={e => setSuggestedItems(Number(e.target.value))}>
                    <option value={50}>50 productos</option>
                    <option value={100}>100 productos (Máximo)</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Descuento (%)</label>
                  <input type="number" className="form-control" placeholder="Ej: 10" value={discount} onChange={e => setDiscount(e.target.value)} />
                </div>
                <div className="col-md-3 d-flex align-items-end">
                  <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox" checked={onlyMainApp} onChange={e => setOnlyMainApp(e.target.checked)} id="mainApp" />
                    <label className="form-check-label fw-bold" htmlFor="mainApp">Solo aplicación principal</label>
                  </div>
                </div>
                {/* CORREO AHORA EN EL FORMULARIO */}
                <div className="col-md-3">
                  <label className="form-label fw-bold">
                    Correo destino del Excel <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="vendedor@empresa.cl"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  <div className="form-text text-muted" style={{fontSize: '0.75rem'}}>
                    El Excel será enviado a este correo una vez autorizado.
                  </div>
                </div>
              </div>

              {/* Indicador de vendedor (si se detectó codv) */}
              {codVendedor && (
                <div className="alert alert-info py-2 small">
                  <strong>Vendedor solicitante:</strong> {codVendedor}
                </div>
              )}

            </div>

            <div className="card-footer text-end bg-light">
              <button
                className="btn btn-success btn-lg px-5 shadow"
                onClick={handleEnviarSolicitud}
                disabled={enviando}
              >
                {enviando
                  ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Enviando solicitud...</>
                  : 'Generar Sugerido'
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SugeridoPage;